export const useRandomColor = (exclude = "fff") => {
  let color = getColor();
  while (color.includes(exclude)) {
    color = getColor();
  }
  return `#${color}`;
};

const getColor = () => {
  return Math.floor(Math.random() * 16777215).toString(16);
};
